import liveServerStatus from '../../liveServerStatus';

/**
 * Generate HTML email template for Weekly Performance Report Reminders
 * @param {Object} employeeData - Employee information
 * @param {Object} weekData - Information about the current week
 * @returns {string} - HTML email content
 */
export const generateWeeklyReminderEmailHTML = (employeeData, weekData) => {
  // Add test environment indicator in the header if not in live environment
  const testEnvironmentBanner = !liveServerStatus ? `
    <div style="background-color: #ffeb3b; color: #333; text-align: center; padding: 5px; font-weight: bold; font-size: 12px;">
      ⚠️ TEST EMAIL - No action required ⚠️
    </div>
  ` : '';

  // Get first name for greeting
  const firstName = employeeData.name ? employeeData.name.split(' ')[0] : 'there';

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Weekly Performance Report Reminder</title>
      <style>
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f5f5f5;
        }
        .email-container {
          max-width: 600px;
          margin: 0 auto;
          background-color: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }
        .email-header {
          background-color: #424242;
          color: white;
          padding: 20px;
          text-align: center;
        }
        .email-header h1 {
          margin: 0;
          font-size: 24px;
          font-weight: 600;
        }
        .email-body {
          padding: 30px;
        }
        .greeting {
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 20px;
          color: #212121;
        }
        .reminder-box {
          background-color: #f5f5f5;
          border-radius: 6px;
          padding: 20px;
          margin-bottom: 25px;
          border: 1px solid #e0e0e0;
        }
        .week-info {
          font-size: 16px;
          font-weight: 600;
          color: #424242;
          margin-bottom: 12px;
        }
        .reminder-message {
          color: #424242;
          margin-bottom: 20px;
        }
        .action-needed {
          background-color: #e8f4fd;
          border-left: 4px solid #2196f3;
          padding: 12px 16px;
          margin: 20px 0;
          font-weight: 500;
        }
        .divider {
          height: 1px;
          background-color: #e0e0e0;
          margin: 25px 0;
        }
        .cta-button {
          display: inline-block;
          background-color: #4a6da7;
          color: white;
          text-decoration: none;
          padding: 12px 25px;
          border-radius: 4px;
          font-weight: 500;
          margin-top: 5px;
          text-align: center;
        }
        .message {
          margin-bottom: 25px;
          color: #424242;
        }
        .email-footer {
          background-color: #212121;
          padding: 20px;
          text-align: center;
          color: #f5f5f5;
          font-size: 12px;
        }
        .company-name {
          font-weight: 600;
          color: #f5f5f5;
          margin-bottom: 8px;
        }
      </style>
    </head>
    <body>
      ${testEnvironmentBanner}
      <div class="email-container">
        <div class="email-header">
          <h1>Weekly Performance Report Reminder</h1>
        </div>
        
        <div class="email-body">
          <div class="greeting">
            Hello ${firstName},
          </div>
          
          <div class="message">
            This is a friendly reminder to submit your weekly performance report.
          </div>
          
          <div class="reminder-box">
            <div class="week-info">Week of ${weekData.startDate} - ${weekData.endDate}</div>
            <div class="reminder-message">
              Please log in to your MyelinZ PPC Portal account and submit your weekly performance report, highlighting your key achievements, challenges, and goals.
            </div>
          </div>
          
          <div class="action-needed">
            Action required: Submit your weekly report by the end of ${weekData.endDate}.
          </div>
          
          <a href="${process.env.REACT_APP_URL || 'https://revamped-ppc.myelinz.com'}/performance-review" class="cta-button">Submit Weekly Report</a>
          
          <div class="divider"></div>
          
          <div class="message">
            Regular reporting helps us track your progress and provide better support. If you have any questions or need assistance, please contact your manager.
          </div>
        </div>
        
        <div class="email-footer">
          <div class="company-name">MyelinZ PPC Portal</div>
          <p>This is an automated message. Please do not reply directly to this email.</p>
          <p>© ${new Date().getFullYear()} MyelinZ. All rights reserved.</p>
          ${!liveServerStatus ? '<p><strong>TEST ENVIRONMENT - No action required</strong></p>' : ''}
        </div>
      </div>
    </body>
    </html>
  `;
};

export default generateWeeklyReminderEmailHTML; 